import { ofType } from "redux-observable";
import { guard } from "../../guards/guard";
import { TypeActionWaterTower } from "../actionWaterTower";
import { checkCollectibleWaterAmountExceedsStorage } from "../checks/checkCollectibleWaterAmountExceedsStorage";
import { pathWaterTowerCollectWater } from "../paths/pathWaterTowerCollectWater";
import { pathWaterTowerOpenQuickSell } from "../paths/pathWaterTowerOpenQuickSell";
export var epicWaterTowerCollectWater = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionWaterTower.Collect), guard(state$, deps, pathWaterTowerCollectWater)([
        checkCollectibleWaterAmountExceedsStorage(pathWaterTowerOpenQuickSell),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/epics/epicWaterTowerCollectWater.ts
// module id = 2505
// module chunks = 3